import React, { Component } from 'react';
import { Table, Input, Form, Button } from 'reactstrap';
import Select from 'react-select';

import MessageForm from '../hocs/MessageForm';
import { cancelReasons } from '../../config';

const { entries } = Object;

export default MessageForm(class ReservationCancelReason extends Component {
  onSubmit = (event) => {
    event.preventDefault();
    if(this.isUnsubmittable()) return;
    const { onAction } = this.props;
    const { cancelReason } = this.state;
    onAction({ type: 'submitReservationCancelReason', payload: { cancelReason } });
  }
  isUnsubmittable() {
    const { validations } = this.state;
    return ['cancelReason'].some(_ => !validations[_]);
  }
  render() {
    const { isActive, } = this.props;
    const { cancelReason } = this.state;
    const options = entries(cancelReasons).map(([k, v]) => ({ label: v, value: k }));
    return (
      <div className="reservation-cancelReason">
        <Form onSubmit={this.onSubmit}>
          <Table>
            <thead>
              <tr>
                <th>取消理由を選択してください。</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <Select
                    value={options.find(_ => _.value === cancelReason) || null}
                    onChange={this.onChangeSelect.bind(this, 'cancelReason')}
                    options={options}
                    isClearable={false}
                    isDisabled={!isActive}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <Button type="submit" color="primary" onClick={this.onSubmit} disabled={this.isUnsubmittable() || !isActive}>OK</Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Form>
      </div>
    );
  }
});
